import { render, staticRenderFns } from "./CVMarker.vue?vue&type=template&id=15a42c15&scoped=true&"
import script from "./CVMarker.vue?vue&type=script&lang=ts&"
export * from "./CVMarker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a42c15",
  null
  
)

export default component.exports